import Money from '../utils/Money';

export const assistanceMessage = (inter) => {
  const client = inter.client;
  const displayedAddress = client.displayedAddress.split(', ');
  return `${inter.user.alias}, je te contacte concernant l'intervention ` +
  `${inter.id} ` +
    `${client.partName} - ${displayedAddress
    } - ${Money.toString(inter.priceTtc, true)} - ${inter.infoDesc.desc}`;
};
